import { useTranslation } from '@lt/localization';
import React from 'react';

import Icon from 'src/components/Icon';

export default function SidebarMenuPayment() {
  const { t } = useTranslation();
  return (
    <div className="menu-payment-item">
      {t('checkout.sidebar.paymentByCard')}
      <Icon type="paymenttype" />
      {t('checkout.sidebar.installmentPayment')}
    </div>
  );
}
